<mat-card>

  <mat-card-header>
    <mat-card-title>Búsqueda de {{'Pedido' | translate}}</mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Número</mat-label>
                <input matInput type="number" formControlName="PedidoId" placeholder="Número"
                  aria-label="Número" (keyup.enter)="onSearch()">
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">Origen</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select  formControlName="ComunidadesOrigen" multiple>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
              <!--<mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{'Comunidad' | translate}} Origen</mat-label>
                <input type="text" matInput [matAutocomplete]="obras"
                  formControlName="ComunidadOrigen" (keyup.enter)="onSearch()">
                <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                  {{ sharedFunctions.formatComunidadName(s) }}
                </mat-option>
              </mat-autocomplete>-->
            </div>
            <div fxFlex=34 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">Destino</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadesDestino" multiple>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
              <!--<mat-form-field appearance="outline" style="width: 100%">
                <mat-label>{{'Comunidad' | translate}} Destino</mat-label>
                <input type="text" matInput
                  [matAutocomplete]="obras" formControlName="ComunidadDestino" (keyup.enter)="onSearch()">
                <i [ngStyle]="{'display': isComunidadSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 0"></i>
              </mat-form-field>
              <mat-autocomplete #obras="matAutocomplete" [displayWith]="displayComunidad">
                <mat-option *ngFor="let s of filteredComunidadesList" [value]="s">
                  {{ sharedFunctions.formatComunidadName(s) }}
                </mat-option>
              </mat-autocomplete>-->
            </div>

            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isEstadoSearching">Estados</mat-label>
                <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                <mat-select formControlName="Estados" multiple>
                  <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}</mat-label>
                <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoMaterialId" (selectionChange)="onSearch()">
                  <mat-option [value]="0">Todos</mat-option>
                  <mat-option *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="!verSoloMisPendientesAprobacion">
                <mat-label *ngIf="!isRolSearching">Rol de Aprobador</mat-label>
                <mat-label *ngIf="isRolSearching">Cargando...</mat-label>
                <mat-select formControlName="RolId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of rolList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isRubroContableSearching">{{'Rubro Contable' | translate}}</mat-label>
                <mat-label *ngIf="isRubroContableSearching">Cargando...</mat-label>
                <mat-select formControlName="RubroContableId">
                  <mat-option [value]="0">Todos</mat-option>
                  <mat-option autocomplete="off" *ngFor="let s of rubroContableList" [value]="s.Id">{{s.Codigo + '. '+ s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=100 fxFlex.xs=50 fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex.xs=50   class="flex-item">
                  <mat-checkbox formControlName="VerSoloMisPendientesAprobacion" (keyup.enter)="onSearch()" color="primary">Ver Solo Mis Pendientes de Aprobación</mat-checkbox>
                </div>

                <div fxFlex.xs=50  class="flex-item">
                  <mat-checkbox formControlName="VerSoloPedidosSinRemitoAdjunto" (keyup.enter)="onSearch()" color="primary">Ver Solo Pedidos Sin Remito Adjunto</mat-checkbox>
              </div>
            </div>


          </div>

        </form>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="add()" *ngIf="canAdd" [disabled]="isSearching" color="primary"
          class="zb-button">Agregar</button>
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary"
          class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="primary"
          class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
        <button mat-raised-button (click)="onExportItem()" [disabled]="isExporting" color="primary"
          class="zb-button">{{isExportingItem ? 'Exportando...' : 'Exportar con Materiales'}}</button>

        <button mat-raised-button (click)="bajaMasiva()" *ngIf="canDelete" [disabled]="isProcessing()" color="warn" class="zb-button">
            {{isDeletingMasivo ? 'Rechazando...' : 'Rechazar Masivamente'}}
        </button>

        <button mat-raised-button fxLayoutAlign="end" (click)="multiSelectionEnabled = !multiSelectionEnabled" [disabled]="isProcessing()" class="zb-button">
            {{multiSelectionEnabled ? 'Cancelar' : 'Selección Múltiple'}}
        </button>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <ng-container *ngIf="!multiSelectionEnabled">
        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
            [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
            [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" (actionBegin)="onActionBegin($event)" (rowDataBound)='rowDataBound($event)'>
            <e-columns>
              <e-column field='Id' headerText='#' textAlign="center" width=50  [clipMode]="'Clip'">
                <ng-template #template let-data>
                  {{data.Id + ' '}}<i class="fa fa-exclamation" *ngIf="data.TieneObservacion" title="Este pedido tiene observaciones en los materiales." aria-hidden="true"></i>
                </ng-template>
              </e-column>
              <e-column field='ComunidadOrigenNombre' headerText='Origen' width=90></e-column>
              <e-column field='ComunidadDestinoNombre' headerText='Destino' width=90></e-column>
              <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
              <e-column field='TipoMaterialNombre' headerText='Tipo de Material' width=90>
                <ng-template #headerTemplate let-data>
                  {{'TipoMaterial' | translate}}
                </ng-template>
              </e-column>
              <e-column field='FechaNecesidad' format="dd/MM/yyyy" headerText='Fecha Necesidad' width=90></e-column>
              <e-column field='FechaLimite' format="dd/MM/yyyy" headerText='Fecha Limite' width=90></e-column>
              <e-column field='FechaEntregaPlanificada' format="dd/MM/yyyy" headerText='Entrega Planif.' type='date' width=90></e-column>
              <e-column field='Observacion' headerText='Observación' width=90></e-column>
              <e-column field='PedidoComunidadRol' headerText='Aprobador' width=90></e-column>
              <e-column headerText='Acciones' textAlign="center" width=90>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                  <a *ngIf="data.PuedeDarDeBaja" style="cursor: pointer; margin-right: 5px" (click)="delete(data)" title="Rechazar pedido">
                    <i class="fas fa-times"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </ng-container>

      <ng-container *ngIf="multiSelectionEnabled">
        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
          <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
            [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
            [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" (actionBegin)="onActionBegin($event)" (rowDataBound)='rowDataBound($event)'>
            <e-columns>
              <e-column type="checkbox" width=30></e-column>
              <e-column field='Id' headerText='#' textAlign="center" width=50></e-column>
              <e-column field='ComunidadOrigenNombre' headerText='Origen' width=90></e-column>
              <e-column field='ComunidadDestinoNombre' headerText='Destino' width=90></e-column>
              <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
              <e-column field='TipoMaterialNombre' headerText='Tipo de Material' width=90>
                <ng-template #headerTemplate let-data>
                  {{'TipoMaterial' | translate}}
                </ng-template>
              </e-column>
              <e-column field='FechaNecesidad' format="dd/MM/yyyy" headerText='Fecha Necesidad' width=90></e-column>
              <e-column field='FechaLimite' format="dd/MM/yyyy" headerText='Fecha Limite' width=90></e-column>
              <e-column field='FechaEntregaPlanificada' format="dd/MM/yyyy" headerText='Entrega Planif.' type='date' width=90></e-column>
              <e-column field='Observacion' headerText='Observación' width=90></e-column>
              <e-column field='PedidoComunidadRol' headerText='Aprobador' width=90></e-column>
              <e-column headerText='Acciones' textAlign="center" width=90>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
                  <a *ngIf="data.PuedeDarDeBaja" style="cursor: pointer; margin-right: 5px" (click)="delete(data)" title="Rechazar pedido">
                    <i class="fas fa-times"></i>
                  </a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </ng-container>

    </ng-container>

  </mat-card-content>
</mat-card>
